<template>
  <div class="page" style="background-color: #ffffff;width: 100%;height: 100%">
    <van-nav-bar
      title="会员疗程"
      left-text="返回"
      left-arrow
      fixed
      @click-left="historyBack"
    />

    
    <el-table :data="cardCourses" border style="width: 100%;margin-top: 45px" height="calc(100% - 45px)" size="mini">
      <el-table-column prop="type"    label="类型" >
        <template slot-scope="scope">
          <span v-if="scope.row.type==2">年疗</span>
          <span v-else>疗程</span>
        </template>
      </el-table-column>
      <el-table-column prop="projectname"    label="疗程名称" ></el-table-column>
      <el-table-column prop="restnumber" label="剩余次数" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.type==2">
            {{$moment(scope.row.validate).format("YYYY-MM-DD")}}
          </span>
          <span v-else>{{scope.row.restnumber}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import empmanager from './empmanager.vue';
export default {
  components: { empmanager },
  data() {
    return {
      cardCourses: [],
      cardid: "",
    }
  },
  created() {
    this.cardid=this.$route.query.cardid;
    this.getCardCourseByCardId();
  },
  methods:{
    getCardCourseByCardId(){
      this.$post("cardinfo/getCardCourseByCardId",{cardid:this.cardid,showRest:0}).then(res=>{
        if(res.sucess){
          this.cardCourses=[];
          let deptid=localStorage.getItem("deptid");
          if(res.object!=null && res.object.length>0){
            for(let val of res.object){
              if(deptid=="32"){
                if(val.projectbigtype==2){
                  this.cardCourses.push(val);
                }
              }
              else{
                if(val.projectbigtype!=2){
                  this.cardCourses.push(val);
                }
              }
            }
          }
          if(this.cardCourses.length<1){
            this.cardCourses=res.object;
          }
          
        }
        else{
          this.$message.error(res.message);
        }
      });
    }
  }
}
</script>
<style style lang="scss" rel="stylesheet/scss">
.page .el-table{
  font-size:10px;
}
</style>



// WEBPACK FOOTER //
// src/page/hair/cardcourse.vue